import { Form, Formik } from "formik";
import { createContext } from "react";
import T from "../common/traducao";

export const UsuarioContext = createContext({
    
});

const UsuarioContextProvider = ({ children }) => {
    const constantes = T();

    return (
        <Formik>
            {() => (
                <>
                    <Form>
                        <UsuarioContext.Provider value={
                            {
                                constantes
                            }}>
                            {children}
                        </UsuarioContext.Provider>
                    </Form>
                </>
            )}
        </Formik>
    )

}

export default UsuarioContextProvider;